<template>
  <main class="wrapper-content w-100">
    <h1>{{ titulo }}</h1>
    <LmComponentLoading v-if="isLoading" fixed />
    <div class="mt-4">
      <h2>{{ documentName }}</h2>
      <a-timeline
        class="mt-4"
        mode="alternate"
        v-if="movements.items.length"
      >
        <a-timeline-item
          v-for="(m, index) of movements.items"
          :key="index"
          :color="m.color || 'gray'"
        >
          <a-icon
            v-if="m.icon"
            slot="dot"
            :type="m.icon"
            style="font-size: 22px;"
          />
          <div class="datos d-flex flex-column mx-2">
            <span class="font-weight-bold" :style="{color: titleColor[m.color]}">{{ m.movement_code }}</span>
            <span>
              <b-avatar
                class="my-2"
                size="2.6em"
                :text="emptyUserAvatar(m)"
                :src="m.avatar"
                v-b-popover.hover="popoverConfig(m, index)"
                :style="{'background-color': titleColor[m.color]}"
              ></b-avatar>
            </span>
            <!-- <span class="font-weight-bold">{{ m.created_by.firstname }} {{ m.created_by.lastname }}</span> -->
            <span
              v-if="m.area && m.subarea"
            >
              {{ m.area.name }} - {{ m.subarea.name }}
            </span>
            <span
              v-if="m.created_at"
              class="font-weight-light"
            >
              {{ m.created_at }}
            </span>
          </div>
        </a-timeline-item>
      </a-timeline>
    </div>
    <hr>
    <LmButton
      id="btn-cancel"
      type="button"
      buttonClass="btn-secondary"
      value="Volver"
      @click="goBackBtn"
      lmButtonRootWrapperClass="d-inline-block mr-1"
      lmButtonWrapperClass="col"
    />
  </main>
</template>

<script>
import commonsApi from '@/api/commons'
import moment from 'moment'
import LmButton from '@/components/form/elements/LmButton'

import 'moment/locale/es'
moment.locale('es')

export default {
  data () {
    return {
      titulo: 'Movimientos',
      documentName: '',
      isLoading: false,
      movements: {
        items: []
      },
      titleColor: {
        red: '#f5222d',
        gray: '#6c757d',
        green: '#52c41a',
        blue: '#1890ff'
      }
    }
  },
  components: {
    LmButton
  },
  methods: {
    goBackBtn () {
      this.$router.go(-1)
    },
    emptyUserAvatar (m) {
      if (m.avatar) {
        return null
      }
      return m.created_by.firstname.charAt(0) + m.created_by.lastname.charAt(0)
    },
    userFullName (m) {
      return `${m.created_by.firstname} ${m.created_by.lastname}`
    },
    popoverConfig (m, index) {
      return {
        content: () => this.userFullName(m),
        placement: index % 2 === 0 ? 'right' : 'left'
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      const documentPromise = commonsApi.axiosGetWrapper(`/documents/${this.$route.params.id}`)

      const movementsPromise = commonsApi.axiosGetWrapper(`/documents/movements/${this.$route.params.id}`)

      const [documentResponse, movementsResponse] = await Promise.all([documentPromise, movementsPromise])
      this.movements.items = movementsResponse.data?.rows || []
      this.documentName = documentResponse.data?.documentName || ''
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
